import { ChemistryVideoError } from './chemistryVideoUtils';

export function loadCanvasImage(src) {
  return new Promise((resolve, reject) => {
    if (!src) {
      resolve(null);
      return;
    }
    const image = new Image();
    if (!src.startsWith('data:') && !src.startsWith('blob:')) image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new ChemistryVideoError('asset_load_failed'));
    image.src = src;
  });
}

async function loadOptionalImage(src) {
  try {
    return await loadCanvasImage(src);
  } catch (error) {
    console.warn('[chemistry-video] optional asset_load_failed', error);
    return null;
  }
}

export async function waitForChemistryVideoFonts() {
  try {
    if (document.fonts?.ready) await document.fonts.ready;
  } catch (error) {
    throw new ChemistryVideoError('font_load_failed', error);
  }
}

export async function loadChemistryVideoAssets({ imageA, imageB, meshImageA, meshImageB, logo }) {
  try {
    const [portraitA, portraitB, meshA, meshB, logoImage] = await Promise.all([
      loadCanvasImage(imageA),
      loadCanvasImage(imageB),
      loadOptionalImage(meshImageA),
      loadOptionalImage(meshImageB),
      loadOptionalImage(logo),
    ]);
    return { portraitA, portraitB, meshA, meshB, logo: logoImage };
  } catch (error) {
    if (error instanceof ChemistryVideoError) throw error;
    throw new ChemistryVideoError('asset_load_failed', error);
  }
}
